import type { useFloating, useInteractions } from '@floating-ui/react';
import classNames from 'clsx';
import React from 'react';

import styles from './CardTitle.scss';

interface Props {
  title: React.ReactNode;
  refs?: ReturnType<typeof useFloating>['refs'];
  getReferenceProps?: ReturnType<typeof useInteractions>['getReferenceProps'];
  className?: string;
}

const CardTitle: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  title,
  refs,
  getReferenceProps,
  className
}) => (
  <h1
    className={classNames(styles.cardTitle, className, {
      [styles.withIcon]: children
    })}
    ref={refs?.setReference}
    {...getReferenceProps?.()}
  >
    {title}
    {children}
  </h1>
);

export { CardTitle };
